import type { AxiosRequestConfig } from "axios";
import axios from "axios";

export type AxiosRequestOptions = Omit<
  AxiosRequestConfig,
  "url" | "data" | "method"
>;

export const axiosRequest = <ResBody = any, ReqBody = any>(
  reqType: "GET" | "POST" | "DELETE",
  url: string,
  data?: ReqBody,
  options?: AxiosRequestOptions,
) => {
  let reqData = {
    ...options,
    method: reqType,
    url,
    data,
  };
  return axios({
    ...reqData,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
